import React from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from '../hooks/useAuth';

const GuestGuard = ({ children }) => {
  const { isAuthenticated, isAdmin, isOps, isStudent, isMentor } = useAuth();

  if (isAuthenticated) {
    if (isAdmin || isOps) return <Redirect to="/soon" />;
    else if (isMentor || isStudent) return <Redirect to="/app/profile" />;
  }

  return <>{children}</>;
};

GuestGuard.propTypes = {
  children: PropTypes.node
};

export default GuestGuard;
